
export default {
  navbar: {
    logOut: "退出登录",
    home: "首页",
    dashboard: "看板",
    screenfull: "全屏",
    exitScreenfull: "退出全屏",
    theme: "换肤",
    size: "布局大小",
    stheme: "特色主题fanti",
  },
  login: {
    title: "Solution Tubo",
    logIn: "登录",
    username: "账号",
    password: "密码",
    oldPassword: "原密码",
    newPassword: "新密码",
    confirmPassword: "确认密码",
    confirmModify: "确认修改",
    idTootip: "请输入正确的用户名",
    passwordTootip: "登录密码不可以少于六位数",
  },
  theme: {
    change: "换肤",
    documentation: "换肤文档",
    tips: "Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。",
  },
  language: {
    message: "切换语言成功",
  },
  
  common: { 
    search: "查询",
    add: "新增",
    clear: "清空",
    copyAdd: "复制增加",
    export: "导出",
    edit: "修改",
    delete: "删除",
    menus: "菜单",
    nodes: "节点",
    modules: "模块",
    operation: "操作",
    cancel: "取消",
    confirm: "确定",
    creator: "创建人",
    createDate: "创建时间",
    please: "请选择",
    pleaseSelect: "请选择",
    pleaseInput: "请输入",
    status: "状态",
    description: "描述",
    startTime: "开始时间",
    endTime: "结束时间",
    pleaseSelectTime: "选择日期",
    all: "共",
    dataCount: "条数据",
    ImagePath:"图片存取路径",
    uploadFile:'点击上传',
    PackagePath:'文件路径',
    DeleteMsg: '确定要删除此方案吗？',
    Tip:'提示',
    CancelDelMsg:'已取消删除',
    imageRequired:'图片',
  },
  
  TurboInfo: {
    industry: "行业",
    pleaseSelect: "请选择",
    pleaseInput: "请输入",
    upload: "上传内容填写",
    solutionName: "解决方案名称",
    description: "描述",
    spIntroduction: "Solution Pack介绍",
    image: "图片",
    spImage: "海报图片",
    package: "文件",
    userManagement: "用户管理",
    email: "邮箱",
    userName: "姓名",
    showUserName: "显示名称",
    firstName:'名',
    lastName:'姓',
    role: "权限状态",
    companyName: "公司名称",    
    phoneNumber: '电话号码',
    country: '国家',
    province:'省份',
    city: '城市',
    createBy: '创建人',
    createDate: '创建日期',
    userImport: '用户导入',
    add: "新增",
    clear: "清空",
    export: "导出",
    role0: '无权限',
    role1: '审核中',
    role2: '可下载',
    
    login: '登录',
    loginOut:'退出登录',
    userRole: '用户角色',
    userAuthority: '用户权限',
    authorityLevel:'权限等级',
    authorityLevelManagment:'权限等级管理',
    authorityManagment: "权限管理",
    uploadData:'上传资料',
    basicDataManagment:"基础数据",
    industryManagment: '行业管理',
    industrySolutionsManagment:'行业解决方案管理',
    technologyManagement: "核心技术管理",
    technologyModeManagement: "核心技术模式管理",
    technologyDetailManagement:'核心技术详情管理',
    sgmindustryManagment: 'SGM行业管理',
    sgmindustrySolutionsManagment:'SGM行业解决方案管理',
    sgmName:'SGM类别',
    sgmDescription:'SGM描述',
    sgmIntroduction: "SGM介绍",

    LeaveMessage:'用户留言',
    isReplied:'处理状态',
    MessageItem:'留言项目',
    MessageContent:'留言内容',
  },
  userAuthorityInfo:{
    userAuthority: '用户权限',
    authorityClass: '权限等级',
    description: "描述",
    userName: "姓名",
    createBy: '创建人',
    lastUpdateBy: '修改人',    
  },
  SGMIndustryManagment:{
    IndMgt: 'SGM行业管理',
    industry: "SGM行业",
  },
  SGMIndustrySolutionsManagment:{
    title: "SGM行业解决方案管理",
    coreName:'SGM行业解决方案名称',
    spIntroduction:'SGM介绍',
    imagePath:'图片存取路径',
    posterPath:'SGM海报存取路径',
    packagePath:'文件存取路径', 
    imgErrMsg: '只能上传 JPG/PNG 格式的图片!', 
    imgSizeErr:'图片大小不能超过 2MB!', 
    spImgSizeErr:'SP图片大小不能超过 10MB!',  
    zipErrMsg: '只能上传 ZIP 格式的文件!', 
    zipSizeErr:'图片大小不能超过 100MB!',  
  },
  IndustryManagment:{
    IndMgt: '行业管理',
    industry: "行业",
  },
  IndustrySolutionsManagment:{
    title: "行业解决方案管理",
    coreName:'行业解决方案名称',
    spIntroduction:'sp介绍',
    imagePath:'图片存取路径',
    posterPath:'SP海报存取路径',
    packagePath:'文件存取路径', 
    imgErrMsg: '只能上传 JPG/PNG 格式的图片!', 
    imgSizeErr:'图片大小不能超过 2MB!',  
    zipErrMsg: '只能上传 ZIP 格式的文件!', 
    zipSizeErr:'图片大小不能超过 100MB!',  
  },
  CoreTechnology:{
    title: '核心技术管理',
    coreName:'核心技术名称',

  },
  CoreTechnologyMode:{
    title: '核心技术模式管理',
    coreName:'核心技术模式名称',
    ModeName:'模式',
    CoreTechnologyID: '核心技术ID',
  },
  CoreTechnologyDetail:{
    title: '核心技术详情管理',
    coreName:'核心技术详情名称',
    DetailName:'详情',
    TechnologyModeID: '核心技术模式ID',
  }

};
